import axios from "axios";
import { useState, useRef, useEffect } from "react";

import Input from '@/components/Input';
import Switch from '@/components/Switch';

import Button from '@/components/Button';

import { getErrorMessage, checkInputErrors } from '@/utils/Errors';

export default function UploadFiles({t,language,user,apiUrl,token,sendMessage,setRootAnswer,handleLogin,openUrlModal}){

    const [ data, setData ] = useState({
        source: '',
        target: ''
    });

    const [ errors, setErrors ] = useState(null);

    const divRef = useRef(null); 

    useEffect(() => {
        // scroll to div
        if(divRef.current) {
            divRef.current.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
            });
        }
        
    }, []);

    const handleInput = (e) => {
        
        var name = e.target.name;
        var value = e.target.value;

        var newData = {...data};
        newData[name] = value;
        setData(newData);
    };

    const handleSubmit = () => {

        const fieldsNotEmpty = ['source'];

        setErrors(null);
        const errorsCheck = checkInputErrors(data,fieldsNotEmpty);

        if(Object.keys(errorsCheck).length === 0){
            
            const apiPath = '/files/uploadAWS';

            const config = {
                headers: { Authorization: `Bearer ${token}` } 
            };

            const send = {...data};

            send.language = language;
            send.companyuser = user?.company;

            var errorMessage = t('root.upload_files.errors.upload');
            
            const url = apiUrl+apiPath;
            
            axios.post(url,send,config)
            .then(function (response) {

                if(response?.data){
              
                    const responseData = response.data;                

                    // if result is ok (1)
                    if(responseData?.result){

                        sendMessage(t('root.upload_files.uploaded'));

                        const render = 
                            <div className='mt-4'>                                       
                                <div className="text-center">
                                    {t('root.upload_files.uploaded')}
                                    {
                                        responseData?.data?.files && responseData?.data?.files?.length > 0 &&
                                        responseData?.data?.files?.map((url) => (
                                            <><br/><a className='cursor-pointer' onClick={() => openUrlModal(url)}>{url}</a></>
                                        ))
                                    }
                                </div>
                            </div>
                        ;                        
                        
                        setRootAnswer(render);
                    } 
                    else{
                        if(responseData?.status && responseData.status === 401){
                            handleLogin();                        
                        }
                        else{
                            // check error message
                            if(responseData?.data?.reasons){
                                errorMessage = getErrorMessage(t,'root.upload_files',responseData?.data?.reasons);                                
                            }
                            
                            sendMessage(errorMessage,'error');
                        }                        
                    }
                }
                else{                
                    sendMessage(errorMessage,'error');                    
                }
            })
            .catch(function (error){
                
                if(error?.status && error.status === 401){
                    handleLogin();                        
                }
                else{                        
                    sendMessage(errorMessage,'error');
                }
            });
        }
        else{            
            const errorMessage = getErrorMessage(t,'root.upload_files',errorsCheck);
            setErrors(errorsCheck);
            sendMessage(errorMessage,'error');
        }
    }

	return (
        <div className='mt-4' ref={divRef}>
            <div className='mb-4'>
                {t('root.upload_files.description')}
            </div>
            <div className='mb-4' key={'root.upload_files.field.source'}>
                <Input                      
                    name='source'
                    type="text"
                    value={data['source']}
                    shrink
                    placeholder={t('root.upload_files.fields.source')}
                    explanation={t('root.upload_files.fields.sourceexplanation')}
                    onChange={handleInput}
                    error={errors && Object.hasOwn(errors,'source') && errors['source'] ? t('root.upload_files.errors.'+errors['source']) : ''}                    
                />
            </div>
            <div className='mb-4' key={'root.upload_files.field.target'}>
                <Input                      
                    name='target'
                    type="text"
                    value={data['target']}
                    placeholder={t('root.upload_files.fields.target')}
                    explanation={t('root.upload_files.fields.targetexplanation')}
                    shrink
                    onChange={handleInput}
                    error={errors && Object.hasOwn(errors,'target') && errors['target'] ? t('root.upload_files.errors.'+errors['target']) : ''}                    
                />
            </div>
            <div className='mb-4 flex justify-center'>
                <div className='me-1'>
                    <Button                     
                        onClick={handleSubmit}
                        text={t('root.upload_files.button')}
                        type='accept'
                    />
                </div>
            </div>
        </div>
    );
}